import { PortalApiClient } from '../portalApiClient';

import { getMessageFromResponse } from './errorHelper';

export async function resetPassword(email: string, client: PortalApiClient) {
  try {
    const response = await client.http.request({
      path: '/api/v1/users/password',
      method: 'POST',
      secure: true,
      body: { email },
    });
    if (!response?.ok) {
      const message = await getMessageFromResponse(response);
      throw new Error(message ?? 'Reset password failed.');
    }
  } catch (e: unknown) {
    console.error(e);
    throw e;
  }
}
